import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import { GlobalService } from 'src/app/api/global.service';

@Component({
  selector: 'app-tag-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
})

export class SelectComponent implements OnInit {

  tags: any = [];
  @Input() selected_tags: any = [];
  @Input() url = 'clients';

  roles: any = [];

  add_tag = {
    title: '',
    colour: '#90ee90',
    description: ''
  }


  constructor(private modalController: ModalController, private apiService: ApiService, public globalService: GlobalService) { }

  ngOnInit() {
    this.GetData();
  }

  async GetData() {
    let data: any = await this.apiService.get(`tags/${this.url}`);
    this.tags = data.data;
    if(this.tags === null) return;
    var tag_title = this.add_tag.title;
    this.tags.forEach(tag => {
      console.log(tag_title);
      if(tag.title === tag_title) this.selected_tags.push(tag);
    });
    this.selected_tags.forEach(tag => {
      var index = this.tags.findIndex(function(item, i){return (item.guid === tag.guid)});
      if(index >= 0)
        this.tags.splice(index,1);
    });
  }

  async Update() {
    this.modalController.dismiss(this.selected_tags);
  }
  async Cancel() {
    this.modalController.dismiss(null);
  }

  async CreateTag() {
    let data: any = await this.apiService.post(`tags/${this.url}`,this.add_tag);
    this.globalService.presentToastMessage(data.message,data.success);
    await this.GetData();
    this.add_tag.title = '';
    this.add_tag.description = '';
  }

}

